import { useCallback } from 'react';
import { TranscriptWord } from 'api';
import { useAudioPlayer } from '../AudioPlayerContext';
import { useWordList, useWordsById } from '../state';
import {
  ActivateWordContext,
  useEditorUiActions,
  useWithDisabledWordSync,
} from '../state/editorUi';
import { getFirstUndeletedWord } from '../Transcript/utils';
import { seekToWord } from '../utils';

export default function useActivateWord() {
  const { data: wordsById } = useWordsById();
  const { data: words } = useWordList();
  const { activateWord } = useEditorUiActions();
  const { player } = useAudioPlayer();

  const withDisabledWordSync = useWithDisabledWordSync();

  return useCallback(
    (word: TranscriptWord, context?: ActivateWordContext): void => {
      if (!word || !words || !wordsById) {
        return;
      }

      const wordId = word.id;

      if (word.isDeleted) {
        const nextActiveWord = getFirstUndeletedWord(wordId, words, wordsById);

        withDisabledWordSync(() => {
          activateWord(wordId, context);
          seekToWord(player, nextActiveWord?.startMillis ?? 0);
        });

        return;
      }

      // seekToWord will cause the word to get "activated" and scrolled into view,
      // but we should be sure to maintain the "activation context".  if seekToWord
      // scrollst he word into view, it will do so with the "playback" context, however
      // we should activate the word here first with the caller's chosen context.
      // the store will prevent one activation request overwriting another
      activateWord(wordId, context);
      seekToWord(player, word.startMillis);
    },
    [activateWord, player, withDisabledWordSync, words, wordsById],
  );
}
